export const photos = {
    largerSide: 1920,
    smallerSide: 1440,
    compression: 0.8,
};
